import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatMoney } from "@/lib/api";
import { SHOP } from "@/constants/testIds";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  return (
    <div
      data-testid={SHOP.card(product.id)}
      className="group bg-white border border-slate-200 hover:border-emerald-900/40 hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow,border-color] duration-500 rounded-sm overflow-hidden flex flex-col"
    >
      <Link to={`/product/${product.slug}`} className="block relative overflow-hidden aspect-square bg-slate-50">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
          loading="lazy"
        />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-emerald-900 text-white text-[10px] font-semibold tracking-wider uppercase px-2 py-1 rounded-sm">
            Best seller
          </span>
        )}
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <p className="overline text-emerald-800 mb-2">{product.category.replace("-", " ")}</p>
        <Link
          to={`/product/${product.slug}`}
          className="font-display font-medium text-slate-900 text-base leading-snug mb-2 line-clamp-2 hover:text-emerald-900"
        >
          {product.name}
        </Link>
        <p className="text-sm text-slate-500 line-clamp-2 mb-5">{product.short_description}</p>
        <div className="mt-auto flex items-center justify-between">
          <div>
            <p className="font-display font-bold text-xl text-slate-900">{formatMoney(product.price)}</p>
            <p className="text-[11px] text-slate-500">SKU {product.sku}</p>
          </div>
          <button
            data-testid={SHOP.addToCart(product.id)}
            onClick={() => addItem(product)}
            className="group/btn flex items-center gap-1 px-3 py-2 bg-slate-900 text-white text-xs font-medium rounded-sm hover:bg-emerald-900 transition-colors"
          >
            <Plus className="w-3.5 h-3.5" />
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
